<template>
  <div>
    <template v-if="resultList.length === 0">
      <van-notice-bar>
        请输入您的身份证号码，我们将为您找回与之关联的账号。
      </van-notice-bar>
      <div style="padding-top: .4rem;">
        <base-form
          ref="form"
          :items="dataSource"
          has-captcha="other"
          label-width="6em"
          submit-text="下一步"
          @submit="onSubmit"
        />
      </div>
    </template>
    <van-cell-group v-else :class="$style.cell">
      <van-cell
        v-for="(e, i) in resultList"
        :key="i"
        :title="e.login_code"
        :label="e.phone ? `绑定手机：${e.phone}` : undefined"
        size="large"
        center
      >
        <template v-if="e.phone" #right-icon>
          <button :class="$style.phone" @click="onSend(e)">
            <van-icon name="share-o" />
          </button>
        </template>
      </van-cell>
    </van-cell-group>
  </div>
</template>

<script>
import { sendAccount, findAccount } from "@/http/user";
import BaseForm from "@/components/BaseForm";

export default {
  name: "findAccount",
  components: { BaseForm },
  data() {
    return {
      // 表单项
      dataSource: [{ name: "idNumber" }],
      // 查询结果列表
      resultList: []
    };
  },
  beforeRouteLeave(to, from, next) {
    // 返回身份证验证层
    if (this.resultList.length > 0) {
      this.clearResult();
      return false;
    }
    // 退出找回账号页面
    next();
  },
  methods: {
    /**
     * @description  找回账号
     * @param {object} formdata  - 表单对象值
     * @param {object} validate  - 验证
     */
    async onSubmit(formdata, validate, callback) {
      findAccount({
        id_code: formdata.idNumber,
        ...validate
      })
        .then(res => {
          if (callback) callback(res.rcode);
          // 查询成功
          if (res.data) {
            this.resetVaildator();
            const values = Object.values(res.data);
            if (values.length > 0) {
              this.resultList = values;
            } else {
              this.$toast("该身份证无绑定账号");
            }
          }
        })
        .catch(() => {
          this.resetVaildator();
        });
    },
    /**
     * @description  发送账号信息
     * @param {object} parmas  - 手机号码、账号ID
     */
    async onSend(parmas) {
      sendAccount({
        player_id: parmas.player_id
      })
        .then(res => {
          if (res.rcode == 0) {
            // 发送成功
            this.$Dialog.alert({
              message: `完整账号已发送至您的绑定手机\n${parmas.phone} \n请您及时查收`
            });
          } else if (res.rcode == 1001) {
            // 找回状态失效
            this.clearResult();
          }
        })
        .catch(() => {})
        .finally(() => {});
    },
    /**
     * @description  重置极致验证状态
     */
    resetVaildator() {
      if (this.$refs.form) {
        if (this.$refs.form.validator) {
          this.$refs.form.validator.reset();
        }
        this.$refs.form.disabled = false;
      }
    },
    /**
     * @description 清空查询结果
     */
    clearResult() {
      this.resultList = [];
      // 返回顶部
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    }
  }
};
</script>

<style module lang="less">
.cell {
  padding: 0.4rem 0;

  :global {
    .van-cell {
      padding: 0.25rem 0.5rem;
    }

    .van-cell__label {
      margin-top: 0.05rem;
    }
  }
}

.phone {
  border: 0;
  background-color: transparent;
  padding: 0;
}
</style>
